export default __webpack_public_path__ + "assets/icons/word-icon.f577601f.svg";